import { render, staticRenderFns } from "./forceTypeList.vue?vue&type=template&id=c84001a6"
import script from "./forceTypeList.vue?vue&type=script&lang=js"
export * from "./forceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports